import * as React from "react"
import {ArticleTemplate} from "../data";

type ReadOnlyArticleTemplateListProps = ReadOnlyValueProps & ReadOnlyCallbackProps

type ReadOnlyValueProps = {
	articleTemplates: ArticleTemplate[]
}

type ReadOnlyCallbackProps = {
	viewArticle: (id: string) => void
}

export const ReadOnlyArticleTemplateList = (props:ReadOnlyArticleTemplateListProps) => {
	//todo: replace with fixed data grid if possible
	return <div>
		<LayoutGrid
			articleTemplates={props.articleTemplates}
			viewArticle={props.viewArticle}
		/>
	</div>
}

const LayoutGrid = (props: ReadOnlyValueProps & ReadOnlyCallbackProps) => {
	return <div className="dataGridPanel sbRoundedEdges" style={{width: '100%'}}>
		<table className="dataGrid sbRoundedEdges" style={{width: '100%'}} cellSpacing="0" cellPadding="2">
			<thead>
			<tr className="dataGridTitlebar sbRoundedEdges" style={{height: '30px'}}>
				<th style={{width: '40px', textAlign: 'center'}}>#</th>
				<th style={{textAlign: 'left'}}>Title</th>
				<th style={{width: '80px', textAlign: 'center'}}>Column</th>
				<th style={{width: '80px', textAlign: 'center'}}>Priority</th>
			</tr>
			</thead>
			<tbody>
			{props.articleTemplates.map((a: ArticleTemplate, i) => {
				return <ArticleTemplateRow
					key={`article-${a.id}`}
					{...a}
					rowClass={i%2 ? 'row1' : 'row0'}
					viewArticle={props.viewArticle}
				/>
			})}
			</tbody>
		</table>
	</div>
}

type RowClass = 'row0' | 'row1'
type ArticleTemplateProps = ArticleTemplate & {
	rowClass: RowClass
	viewArticle: (id:string) => void
}
const ArticleTemplateRow = (props: ArticleTemplateProps) => {
	const viewOnClick = () => props.viewArticle(props.id)
	return <tr className={props.rowClass} onClick={viewOnClick}>
		<td style={{textAlign: 'center', cursor: 'pointer'}}>{props.id}</td>
		<td style={{textAlign: 'left', cursor: 'pointer'}}>{props.title}</td>
		<td style={{textAlign: 'center', cursor: 'pointer'}}>{props.column}</td>
		<td style={{textAlign: 'center', cursor: 'pointer'}}>{props.priority}</td>
	</tr>
}



// WEBPACK FOOTER //
// ./src/communications/article-templates/read-only/presentation.tsx